module.exports = __webpack_public_path__ + "img/battery-good.0d0235b7.png";